// extracted by mini-css-extract-plugin
export var section = "formMain-module--section--Dm0zS";
export var head = "formMain-module--head--zjNlH";
export var formBtnOuter = "formMain-module--formBtnOuter--N+10h";
export var title = "formMain-module--title--ZBfAC";
export var formBtn = "formMain-module--formBtn--uKA7n";